<div class="modal-backdrop" [@modalFadeIn]>
  <div class="modal-container">
    <div class="modal add-payer-dialog">

      <!-- Header -->
      <div class="modal-header">
        <div class="modal-header-content">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 256 256" fill="currentColor" class="modal-header-icon">
            <path d="M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM32,96H224v24H32Z" opacity="0.3"/>
            <path d="M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,144H32V64H224ZM32,96H224v24H32Z"/>
            <path d="M128,140a12,12,0,1,1-12,12A12,12,0,0,1,128,140Z"/>
          </svg>
          <div>
            <h3 class="modal-title">Adicionar Pagador Externo</h3>
            <p class="modal-subtitle">Informe o CNPJ da empresa pagadora</p>
          </div>
        </div>
        <button mat-icon-button (click)="onCancel()" aria-label="Fechar">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-dialog-content class="modal-body">

        <!-- Informação -->
        <div class="alert alert-info">
          <mat-icon>info_outline</mat-icon>
          <span>O pagador externo receberá uma notificação e precisará aceitar antes que você possa solicitar a cobrança.</span>
        </div>

        <!-- Campo CNPJ -->
        <div class="form-section">
          <label class="field-label" for="cnpj-input">CNPJ do Pagador</label>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Digite o CNPJ</mat-label>
            <input
              matInput
              id="cnpj-input"
              type="text"
              placeholder="00.000.000/0000-00"
              [value]="payerCnpj()"
              (input)="onCnpjInput($event)"
              maxlength="18"
              autocomplete="off">
            <mat-icon matPrefix>business</mat-icon>
            <mat-error *ngIf="cnpjError()">{{ cnpjError() }}</mat-error>
          </mat-form-field>
        </div>

        <!-- Exemplo -->
        <div class="help-text">
          <mat-icon class="help-icon">help_outline</mat-icon>
          <span>Exemplo: 12.345.678/0001-90</span>
        </div>

      </mat-dialog-content>

      <!-- Footer -->
      <mat-dialog-actions class="modal-footer">
        <button mat-button (click)="onCancel()">
          Cancelar
        </button>
        <button
          mat-flat-button
          color="primary"
          (click)="onConfirm()"
          [disabled]="!payerCnpj()">
          <mat-icon>person_add</mat-icon>
          Adicionar Pagador
        </button>
      </mat-dialog-actions>

    </div>
  </div>
</div>
